export default {
  title: 'Mettre à jour vos clauses bénéficiaires',
  help: 'Dans un contrat d\'assurance-vie, la clause bénéficiaire permet de définir la ou les personnes qui vont percevoir les fonds au décès du souscripteur. Le contenu de la clause a un impact direct sur la répartition et le coût global de la transmission. Il est conseillé de revoir les clauses de ses contrats tous les 5 ans',
  lifeInsurance: {
    heading: {
      taxationTitle: 'Fiscalité du contrat en cas de décès :',
      beneficiariesTitle: 'Désigner le(s) bénéficiaire(s) de la clause :',
    },
  },
}
